import React from 'react';

import $ from 'jquery';
import emitter from "./ev.js"
import {Message,Notification} from 'element-react';
import ReactDOM from 'react-dom';

class KeeVue extends React.Component {
	constructor(props) {
		super(props);

		if(!window.jzEventBus)
		{
			window.jzEventBus = {};
		}

	}
	
	addListener(eventName, callback){
		
	 
		
		if(callback&&typeof callback ==="function")
		{
			if(!window.jzEventBus[eventName])
			{
				window.jzEventBus[eventName]=[];
			}
			
			for(let i=0;i<window.jzEventBus[eventName].length;i++)
			{
				if(window.jzEventBus[eventName][i].owner===this)
				{
					console.log("事件已绑定"+eventName+" name："+(this.props.component?this.props.component.name:' weizhi'));
					return window.jzEventBus[eventName][i];
				}
			}
			let bus = {
				id:this.props.component?this.props.component.id:'system',
				owner:this,
				eName:eventName,
				cb:callback
			};
			
			window.jzEventBus[eventName].push(bus);
			return bus;
		}
		
		return null; 
		 
	}
	removeListener(p){
		if(window.jzEventBus)
		{ 
			window.jzEventBus[p.eName].remove(p); 
		}
	}
 
	onEvent(eventName, callback, target) { 
		//console.log("绑定事件："+eventName);
		
		

		if (!this.eventEmitters) {
			this.eventEmitters = {}
		}
		let eventNo = this.state.randId+eventName;
  
		//this.log("绑定事件:"+eventName);
		this.eventEmitters[eventNo] = this.addListener(eventName, callback);
		//console.log("监听事件长度："+Object.keys(this.eventEmitters).length  );
		
		

	}

	sendEvent(eventName, obj, obj2, obj3, obj4, obj5, obj6) {
		
		if(this.unmounted)
		{
			return ;
		}
		
		if(eventName.indexOf(".render")!=-1)
		{
			
		}
		else
		{
		//	console.log((this.props.component ? this.props.component.alias : '') + "发送全局消息消息：" + eventName);
		}
		//console.log((this.props.component ? this.props.component.alias : '') + "发送全局消息消息：" + eventName);

		// emitter.emit(eventName, obj, obj2, obj3, obj4, obj5, obj6)
		
		if(window.jzEventBus[eventName])
		{
			window.jzEventBus[eventName].map((item,index)=>{
				
				item.cb( obj, obj2, obj3, obj4, obj5, obj6);
				
			})
		}
		
		//帮vue也发送一下事件
		   
			window.getEventHub().$emit(eventName, obj, obj2, obj3, obj4, obj5, obj6);
			
		 
		
		 
		

	}
	$on(eventName, callback) {
		if (!this._myEventMap) {
			this._myEventMap = {};
		}

		this._myEventMap[eventName] = callback;
	}

	$emit(eventName, obj, obj2, obj3, obj4, obj5, obj6) {
// console.log("组件自身发起事件"+eventName);
if(this.props.component)
{
	// console.log("组件："+this.props.component.alias+"自身发起事件"+eventName);
	
}
		if(this.unmounted)
		{
			return ;
		}
		// let evt = new CustomEvent(eventName, {
		// 	 bubbles:true,cancelable:true,
		//      detail: {
		//          obj: obj,
		//          obj2:obj2,
		// 		 obj3:obj3,
		// 		 obj4:obj4,
		// 		 obj5:obj5,
		// 		 obj6:obj6,
		//      }
		//  });

		// this.props.onHelp(evt);

		// 触发, 即弹出文字
		// if(this.myDom)
		// {
		// 	this.myDom.dispatchEvent(evt );
		// }

		if (this._myEventMap && this._myEventMap[eventName]) {
			// console.log("组件自身 xiangying:"+eventName);
			
			try{
				this._myEventMap[eventName].bind(this)(obj, obj2, obj3, obj4, obj5, obj6);
			}
			catch(err)
			{
				 console.log("组件自身 xiangying:"+eventName);
				 
				console.error(err);
			}
			

		}

		// 改为直接调用的方式
		for (let p in this.props) {
			if (p.indexOf("on") == 0 && typeof this.props[p] == 'function') {
				let ename = p.replace("on", "");
				ename = ename.charAt(0).toLowerCase() + ename.slice(1);

				if (eventName.toLowerCase() == ename.toLowerCase()) {
					// console.log("组件自身 上级组件相应");
					this.props[p](obj, obj2, obj3, obj4, obj5, obj6);
					this.refresh();
				}

				// this[p+"callback"] = function(evt){
				// 	that.props[p](evt.detail.obj,evt.detail.obj2,evt.detail.obj3,evt.detail.obj4,evt.detail.obj5,evt.detail.obj6)
				// };
				// this.myDom.addEventListener(ename, this[p+"callback"]);
			}
		}

	}

	componentWillUnmount() {
		//this.log('卸载组件:')
		// 避免异步调用导致渲染异常
		this.unmounted = true;
		 this.setState = (state,callback)=>{
		      return;
		    };
	//this.log("移除事件：");

		if (this.eventEmitters) {
			for (let p in this.eventEmitters) {
				if (typeof this.eventEmitters[p]) {
					//this.log("移除事件："+p);
					this.removeListener(this.eventEmitters[p]);
				}

			}
		}

		for (let p in window.CReactMap) {
			if (window.CReactMap[p] == this) {
				// console.log("卸载主键："+this.props.component.id+" "+this.props.component.alias)
				window.CReactMap[p] = null;
			}
			//				CMap[this.component.viewName].viewer[this.component.alias] = this;
			//				CMap[this.component.viewName][this.component.alias] = this;

		}
		// if (this.props.component  && this.props.component.viewName ) {
		// 	for (let p in window.CReactMap[this.props.component.viewName]) {
		// 		if (window.CReactMap[this.props.component.viewName][p] == this) {
		// 			window.CReactMap[this.props.component.viewName][p] = null;
		// 		}
		// 	}
		// 	if (window.CReactMap[this.props.component.viewName].viewer ) {
		// 		for (let p in window.CReactMap[this.props.component.viewName].viewer) {
		// 			if (window.CReactMap[this.props.component.viewName].viewer[p] == this) {
		// 				window.CReactMap[this.props.component.viewName].viewer[p] = null;
		// 			}
		// 		}
		// 	}

		// }
 
	}

	showMessage(msg) {
		if (msg == null) {

			return;
		}
		
		if (window.isPub ) {
					if(typeof msg == "string")
					{
						this.sendEvent("toast",msg);
					}
					else
					{
						this.sendEvent("toast",msg.message);
					}
					
					return;
		}
		else
		{
			if(typeof msg == "string")
			{
				Notification({
				  type: 'success',
				  duration:3000,
				  message: msg
				})
			}
			else
			{
				if(msg.success)
				{
					Notification({
					  type: 'success',
					  duration:3000,
					  message: msg.message
					})
				}
				else
				{
					Notification({
					  type: 'success',
					  duration:3000,
					  message: msg.message
					})
				}
			}
		}
		
		
		
	 

	}

	showErrorMessage(msg) {
		
		 
		if (window.isPub ) { 
					
					this.sendEvent("toast",msg);
					return;
		}
				
		else
		{
			Notification.error({
			  type: 'danger',
			  duration:6000,
			  message: msg
			})
		}
		 
		
	}
	getUrlParameter(name){
		if(name)
		{
			
			
			let query = window.location.search.substring(1);
			let vars = query.split("&");
			for (let i=0;i<vars.length;i++) {
					let pair = vars[i].split("=");
					if(pair[0] === name){return pair[1];}
			}
			
			if(window.QueryParaData && window.QueryParaData.indexOf('#')!=0)
			{
				let temp = JSON.parse(window.Base64.decode(window.QueryParaData));
				
				if(temp[name])
				{
					return temp[name];
				}
			}
			
		}
		
		return '';
	}
	
	refresh(obj) {
		this.needRefresh = true;
		if(obj)
		{
			this.setState(obj);
		}
		else
		{
			this.setState(this.state);
		}
		
		//this.setState(this.state);
		//this.sendEvent("refresh");
	}
	
	refreshComponent(id,name) {
		if(id)
		{
			 
				this.sendEvent(id+"-"+name+".render");
			 
		}
		else
		{
			if(this.props.po&&this.props.po.id)
			{
				this.sendEvent(this.props.po.id+"-"+this.props.po.name+".render");
			}
		}
		
	}
	
	



	getCookie(name) {

		if (name == "token") {
			if (typeof window.keyName != "undefined" && window.keyName != "") {
				name = window.keyName + "_token";

				let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

				if (arr = document.cookie.match(reg))

					return unescape(arr[2]);
				else
					return null;
			}
		}

		let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

		if (arr = document.cookie.match(reg))

			return unescape(arr[2]);
		else
			return null;
	}



	// doRequest(url, callBack, submitData, withCache) { }
	
	//////////////////////////////////////////////////////////////
	  doRequest(url, callBack, submitData, withCache) { 
		  console.log("window.currentToken=="+url);
		  
		   let ck = this.getCookie("token");
		   
		  if(!window.currentToken||window.currentToken=="\"\"")
		  {
			 
		  	if(window.keyName)
		  		{
		  			window.currentToken = ck; 
		  		}
		  		
		  }
		  			 
		  	//alert(window.currentToken!="");
		  if(!window.isPub&&window.keyName&&ck&&ck!='""'&&window.currentToken&&window.currentToken!="\"\""&&window.currentToken!=ck)
		  {
		  	//alert( "登录状态变化，将自动刷新页面" );
			// debugger;
		  	// window.location.reload();
		  	// return ;
		  }
		   
		   
		  
			// 如果是配置数据，且index。html里面已经包含了，就直接返回
		  let Base64 = window.Base64;
			if(url&&url.indexOf("/clientConfig/getMap")!=-1)
			{
				if(window.ClientConfigData&&window.ClientConfigData!='#escape(clientConfigData)')
				{  
					console.log("使用index数据")
					setTimeout(()=>{
						callBack(JSON.parse(Base64.decode(window.ClientConfigData)));
					},10);
					
					return ;
				}
			}
			 
			if(url&&url.indexOf("/mainFrame/getMainInfo")!=-1)
			{
			
			   url = window.rootUri+"/mainFrame/getMainInfo";	
				
				if(window.mainInfoConfigData&&window.mainInfoConfigData!='#escape(mainInfoConfigData)')
				{  
					console.log("使用index数据")
					setTimeout(()=>{
						callBack(JSON.parse(Base64.decode(window.mainInfoConfigData)));
					},10); 
					return ;
				}
			}
			 
		  	  let keeVueAppCacheMap = window.keeVueAppCacheMap;
		  	  let hasPermission = window.hasPermission;
		  	  let rootUri = window.rootUri;
			  
			  
			  let pathName = window.location.pathname.replace("//","/");
			  
			  pathName = pathName.substring(0,pathName.lastIndexOf("/")); 
			  
			  
			   
			  //var url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
			  if(process.env.NODE_ENV=='development')
			  {
			  	window.rootUri=window.webUrl; 
			  }
			  
			 //  if(  window.rootClientWebPath)
			 //  {
			 //  				  rootUri = window.rootClientWebPath;
			 //  }
			  
			  
			  
			 //  if(   window.rootClientWebPath)
			 //  { 
				//   let protocolStr = document.location.protocol;
				//   if(protocolStr == "https:")
				//   {
				//      window.rootClientWebPath = window.rootClientWebPath.replace("http://","https://");
				//   }
				//   window.rootUri = window.rootClientWebPath;
			 //  }
			  
			 //  if(window.ClientConfigData &&window.ClientConfigData.indexOf('#')!=0)
			 //  {
			 //  	let temp = JSON.parse(Base64.decode(window.ClientConfigData));
				// if(temp&&temp.rootWebPath)
				// {
				// 	window.rootUri = temp.rootWebPath;
				// }
			  	 
			 //   }
			  
		  	 
		  	  let showErrorMessage = window.showErrorMessage;
		  	  let getCookie = window.getCookie;
		  	  let tid = window.tid;
		  	  let currentUserOrgId = window.currentUserOrgId;
		  	  let keyName = window.keyName;
		  	  let envName= window.envName;
		  	  let encrypt = window.encrypt;
		  	  let encryptByDES = window.encryptByDES;
		  	  
		  	  let mainVueApp = window.mainVueApp;
		  	  let _sign = window._sign;
		  	  let _rsakey = window._rsakey;
		  	  let _publicKey = window._publicKey;
		  	  
			 // console.log("_publicKey:"+window._publicKey);
			//  console.log("_publicKey222:"+window._publicKey22);
			  
			  
		 // console.log("url关键字0：huidiao:" + url);
		  	if(typeof url=="undefined"||url == null || url.trim() == ''||url=='undefined') {
		  		return;
		  	}
		  	let yuanUrl = url;
		 
			
			console.log("url关键字：" + url);
			if(withCache == null || withCache == true||url.indexOf("keePage/getByCode")!=-1) {
				if(url.indexOf("keePage/getByCode") != -1   ||url.indexOf("keeVueApp/getAppConfig") != -1   || url.indexOf("/sysPrivilege/getIconList") != -1) {
					for(var i = 0; i < keeVueAppCacheMap.length; i++) {
						if(yuanUrl.indexOf(keeVueAppCacheMap[i].url+"&")!=-1) {
							// 执行回调函数
							console.log("从缓存获取数据：" + yuanUrl);
							callBack(JSON.parse(JSON.stringify(keeVueAppCacheMap[i].data)));
							return;
						}
					}
				}
			}
			
		  
		  	// url = getFullUrl(url);
		  
		  //	console.log("doRequest请求地址>>>>>>>>>>：" + url);
		  	if(url == "")
		  		return;
				
			if(url.indexOf("http")!==0)
			{
				url=window.rootUri+url;
			}
		  	
		  
		  	let protocolStr = document.location.protocol;
		  	if(protocolStr == "https:"&&url.indexOf("https")!=0)
		  	{
		  	   url = url.replace("http://","https://");
		  	}
		  
		  	 
		  	
		  
		  	let sessionkey = window.getCookie("token");
		  
		  	let token = window.getCookie("token");
		  
		  	if(typeof submitData =="undefined")
		  	{
		  		submitData = {};
		  	}
			
			let defaultOrgId = window.currentUserOrgId ;
			
			// 如果是网站模式，使用网站的orgId
			if(window.currentOrgId&&window.appCode)
			{
				defaultOrgId = window.currentOrgId;
			}
			if(!defaultOrgId)
			{
				defaultOrgId = "";
			}
		  	
		  	let postData = $.extend( {
		  		// sessionkey: sessionkey,
		  		tid: tid,
		  		isWrap: "true",
		  		currentOrgId: defaultOrgId,
		  	},submitData);
		  	
		  	let p = {};
		  
		  	if(keyName) {
		  		token = getCookie(keyName + "_token");
				if(window.jczl_min_token){
					token = window.jczl_min_token ; 
				}else{
					token = this.getCookie(keyName + "_token");
				}
		  
		  		 p = {
		  			tid: tid,
		  			keyName: keyName,
		  			// sessionkey: sessionkey,
		  			isWrap: "true",
		  			currentOrgId:defaultOrgId,
		  		};
		  		p[keyName + "_token"] = token;
		  
		  		postData = $.extend(p,submitData);
		  	}
		  	
		  	let fromKeyName = this.getQueryVariable("keyName");
		  	
		  	let urlToken = this.getQueryVariable(keyName + "_token");
		  	if(fromKeyName&&urlToken)
		  	{
		  		p[fromKeyName + "_token"] = urlToken;
				token = urlToken;
		  	}
			
			if(token&&token!='""')
			{
				if(!window.loginedToken)
				{
					window.loginedToken = token;
				}
				else{
					if(window.loginedToken!=token)
					{
						//window.location.reload();
						
						if(window.loginUrl)
						{
							window.location.href = window.loginUrl
						}
					}
				} 
			}
			
			
			
			
		  	
		  	
		  	if(typeof envName != "undefined" &&envName!=null && envName != "") 
		  	{
		  		postData.envName = envName;
		  	}
		  	else
		  	{
		  		postData.envName="blank";
		  	}
		  	
			let isPreview = window.isPreview||this.getUrlParameter("isPreview");
			 
		  	if(url.indexOf("keePage/getByCode") != -1&&isPreview)
		  	{
		  		postData.isPreview=isPreview;
		  		postData.appId = this.getUrlParameter("appName")+token;
		  	}
			
			
			// 天权的几个参数
			let accessToken = this.getUrlParameter("accessToken"); 
			if(accessToken)
			{
				postData.accessToken=accessToken; 
			}
			
			let openId = this.getUrlParameter("openId");
			if(openId)
			{
				postData.openId=openId; 
			}
			
			let refreshToken = this.getUrlParameter("refreshToken");
			if(refreshToken)
			{
				postData.refreshToken=refreshToken; 
			}
			
			
			//debugger;
			
			
			
		  	
			// 增加调入方需要往后传递的参数问题
			
			let headers = {
				
			}
			if(window.ClientInsConfig&&window.ClientInsConfig.tianquanPara)
			{
				let paras = window.ClientInsConfig.tianquanPara.split(",");
				
				for(let m=0;m<paras.length;m++)
				{
					headers[paras[m]] = this.getQueryVariable(paras[m]);
				}
			}
			
		  	
		  	// 排除文件上传接口
		  	
		  	if( window._sign &&window._sign!="#escape(_sign)"&&url.indexOf("/keePage/getByCode")==-1&&url.indexOf("/keeUploadFile/")==-1&&url.indexOf("/importPages")==-1)
		  	{
		  		postData.envName2 = window.encryptJz(_publicKey,postData.envName);
		  		
		  		// 将url中的参数剔除，采用postData传输；
		  		if(url.indexOf("?")!=-1)
		  		{
		  			let urlPara = url.substring(url.indexOf("?")+1);
		  			let paras = urlPara.split("&");
		  			
		  			for(let i=0;i<paras.length;i++)
		  			{
		  				if(paras[i]!=null&&paras[i]!="")
		  				{
		  					let keyValue = paras[i].split("=");
		  					if(keyValue.length>0)
		  					{
		  						postData[keyValue[0]] = "";
		  					}
		  					if(keyValue.length>1)
		  					{
		  						postData[keyValue[0]] = keyValue[1];
		  					}
		  				}				
		  			}
		  			url = url.substring(0,url.indexOf("?"));
		  		}
				
				
				if(url.indexOf("?")==-1)
				{
					url+="?";
				}
				
		  		
		  		postData.retBase64=1;
		  		
		  		console.log("加密前："+JSON.stringify(postData));
		  		// 设置了加密签名		
		  		let postDataJson = JSON.stringify(postData);	
		  		// 可能还有一个开放接口，比如tid，currentOrgId 等，不方便全部隐藏；
		  //		if(submitData!=null)
		  //		{
		  //			for(let sp in submitData)
		  //			{
		  //				 postData[sp] = "";
		  //				 
		  //			}
		  //		}
		  		postData = {};
		  		postData._sign = _sign;
		  		postData.rsakey = _rsakey;		
		  		postData._data = encryptByDES(postDataJson,_rsakey);		
		  	}
		  	
		  	 
		  	console.log(JSON.stringify(postData));
		  
		  	if(url.indexOf("delete") != -1 || url.indexOf("remove") != -1) { //删除操作都要警告
		  		if(hasPermission('P_DELETE') || url.indexOf("remove") != -1) {
		  
		  			mainVueApp.$confirm('此操作将删除该数据, 是否继续?', '提示', {
		  				confirmButtonText: '确定',
		  				cancelButtonText: '取消',
		  				type: 'warning',
		  				callback:  (action, instance)=> {
		  					if(action == "confirm") {
		  						if(url.indexOf("http") != 0 && url.indexOf(rootUri) != 0) {
		  							url = rootUri + url;
		  						}
		  
		  						$.ajax({
		  							url: url,
		  							type: 'POST',
		  							 
		  							cache: false,
		  							dataType: "json",
		  							data: postData,
		  							xhrFields: {withCredentials: true},
		  							success: function(data) {
		  								// console.log(url, data);
		  								if(this.unmounted)
		  								{
		  									return ;
		  								}
		  								if(typeof data._data!="undefined"&&data._data!=null)
		  								{
		  									data = JSON.parse(Base64.decode(data._data));
		  								 
		  								}
		  								
		  								if(data.error!=null)
		  								{
		  									if(data.error==0)
		  									{
		  										callBack(data.ret);
		  									}
		  									else
		  									{
		  
		  										if(typeof showErrorMessage != "undefined") {
		  											 showErrorMessage(data.errorMessage);
		  											 return ;
		  										}
		  										else
		  										{
		  											alert(data.errorMessage);
		  											return ;
		  										}
		  									 
		  									}
		  									
		  								}
		  								else
		  								{
		  									callBack(data);
		  								}
		  								
		  							},
		  							error: function(XMLHttpRequest, textStatus, errorThrown) {
		  								console.log("网络连接错误：" + yuanUrl + " 错误码1：" + XMLHttpRequest.status + " " + XMLHttpRequest.readyState + " " + textStatus);
		  							}
		  						});
		  					}
		  
		  					if(action == "cancel") {
		  						mainVueApp.$message({
		  							type: 'info',
		  							message: '已取消删除'
		  						});
		  					}
		  				}
		  			});
		  
		  		} else {
		  			mainVueApp.$message({
		  				type: 'info',
		  				message: '您没有删除数据权限'
		  			});
		  		}
		  
		  	} else {
		  		let yuan = url;
		  		if(url.indexOf("http") != 0) {
					if(window.ClientInsConfig&&window.ClientInsConfig.rootWebPath)
					{
						rootUri = window.ClientInsConfig.rootWebPath;
					}
					else
					{
						let pathName = window.location.pathname.replace("//","/");
						
						pathName = pathName.substring(0,pathName.lastIndexOf("/"));
						
						rootUri = window.location.protocol+"//"+window.location.host+pathName;
						
					}
		  			url = rootUri + url;
		  		}
		  		let that = this;
		  		
				if(!window.reqList)
				{
					window.reqList=[];
				}
		  		
					let reqList=window.reqList;
		  		
		  		let key = url+JSON.stringify(postData);
		  		
		  		let existsReq = false;
		  		let nowTime = new Date();
		  		
		  		//console.log("huidiao:请求数量"+reqList.length);
		  		for(let t=0;t<reqList.length;t++)
		  		{
		  			let m = reqList[t];
		  			
		  			if((nowTime.getTime()-m.pTime.getTime())>500||m.cbList.length==0)
		  			{ 
		  				reqList.remove(m);
		  				//console.log("删除过期请求："+m.key);
		  				t--;
		  			}
		  		}
		  		
		  		//console.log("huidiao:请求数量"+reqList.length);
		  		let mtemp = {};
		  		for(let t=0;t<reqList.length;t++)
		  		{
					let m = reqList[t];
		  			if((nowTime.getTime()-reqList[t].pTime.getTime())>500||m.cbList.length==0)
					{
						console.log("超时500");
						continue;
					}
					
					// 没有超时，但是列表已经空了，说明
		  			 
		  			if(reqList[t].key==key)
		  			{
		  				mtemp = reqList[t];
		  				// 看看有没有过期 
		  				existsReq = true;
		  				if(mtemp.retData)
		  		 		{
		  		 			// 找到了数据，直接回调
		  					
		  					that.callBackFunction = callBack;
		  		
		  					// 改变调用域 
		  					if(that.callBackFunction!=null&&typeof that.callBackFunction=="function")
		  					{
		  						console.log("直接使用缓存数据返回"+url);
		  						let tempData = JSON.parse(JSON.stringify(mtemp.retData));
		  						setTimeout(function(){
		  							that.callBackFunction.call(that, tempData );
		  						},20);
		  						
		  						
		  						
		  						return;
		  					}
		  		 		}
		  				else
		  				{
		  					//console.log("回调列表长度："+mtemp.cbList.length);
		  					// 告知那个线程，请求到了数据回调一下
		  					mtemp.cbList.push({"from":that,"cb":callBack});
		  				//	console.log("huidiao:回调列表长度："+mtemp.cbList.length+",直接返回");
		  					return;
		  				}
		  			}
		  			
		  			
		  		}
		  		
		  		
		  		
		  		
		  		
		  		console.log(" ajaxCallBack line" );
		  		
		  		this.ajaxCallBack = (response)=> {
		  			
		  		//	console.log("huidiao:url:"+url) 
		  			let data = response;
		  
		  			if(response == null) {
		  				console.log(" 请求数据出错：：" + url);
		  				return;
		  			}
		  			
		  			if( response._data )
		  			{
		  				let text = Base64.decode(response._data);
		  				data = JSON.parse(text);
		  				if(data==null)
		  				{
							console.log(" 获取数据出错：：" + url);
		  					data={
		  						"success":false,
		  						"message":"获取数据出错！"
		  					};
		  				}
		  				response = data;
		  			}
		  			
		  			if(response.error!=null)
		  			{
						
						if(response.error==-100&&response.message&&response.message.indexOf("登录")!=-1)
						
						{
							// 需要重新登录
							
							if(window.loginUrl)
							{
								window.location.href = window.loginUrl
							}
							console.error("数据请求错误2："+url);
							if(window.loginedTokenNew)
							{
								//window.location.reload();
								// return;
							}
							
							
							
							/*
							if(window.loginedToken)
							{
								window.location.reload();
								return ;
							}*/
							 
							  
							
						}
						
		  				// if(response.error==0)
		  				// {
		  				// 	data = response.ret;
		  				// }
		  				// else
		  				// {
		  				// 	if(typeof showErrorMessage != "undefined") {
		  				// 		 showErrorMessage(data.errorMessage);
		  				// 		 return ;
		  				// 	}
		  				// 	else
		  				// 	{
		  				// 		alert(data.errorMessage);
		  				// 		return ;
		  				// 	}
		  				// }
		  			}
		  			
		  
		  			if(data.success == false) {
		  				if(data.message&&data.message.indexOf("IP来源")!=-1)
		  				{
		  					//alert("IP参数错误！");
		  				}
		  				 
						if(window.showErrorMessage ) {
		  					window.showErrorMessage(data.message);
		  				}
						
						
		  				if(data.exceptionId!=null)
		  				{
		  					console.error("点击查看错误详情： http://cpaas.dev.xjoycity.com/watchExceptionLog/getDetail?id="+data.exceptionId);
		  				}
		  			}
		  
		  			// 缓存数据
		  			if(url.indexOf("keePage/getByCode") != -1   ||url.indexOf("keeVueApp/getAppConfig") != -1 ||   url.indexOf("/sysPrivilege/getIconList") != -1) {
		  			
		  				let exists = false;
		  				for(var i = 0; i < keeVueAppCacheMap.length; i++) {
		  					if(keeVueAppCacheMap[i].url == yuanUrl) {
		  						exists = true;
		  					}
		  				}
		  				
		  				let urlKey = yuanUrl;
		  				// if(url.indexOf("keePage/getByCode") != -1&&url.indexOf("preFetch")==-1 )
		  				// {
		  				// 	urlKey= urlKey.replace("&rootUri=&","");
		  				// 	urlKey+="&preFetch=true&rootUri=&"
		  				// }
		  				
		  				console.log("缓存urlKey："+urlKey);
		  			
		  				if(!exists) {
		  					keeVueAppCacheMap.push({
		  						url: urlKey,
		  						data: data
		  					});
		  					 
		  				}
		  				
		  				if(url.indexOf("keePage/getByCode") != -1  )
		  				{
		  					// 需要异步获取一下该应用的其他页面
							if(data.description)
							{
		  					let pageCodes = data.description.split(",");
							
							if(!window.loadedPageCodes)
							{
								window.loadedPageCodes={};
							}
		  					
		  					setTimeout(()=>{
		  						for(let p=0;p<pageCodes.length;p++)
		  						{
									// 加载过的不能重复加载！ 
									// jdcc.vueComponent 排除
									 
		  							if(pageCodes[p]&&!window.loadedPageCodes[pageCodes[p]]&&pageCodes[p].indexOf("jdcc.vueComponent")==-1)
		  							{
										window.loadedPageCodes[pageCodes[p]]=true;
		  								this.doRequest("/keePage/getByCode?code="+pageCodes[p],()=>{});
		  							}
		  						}
		  					},100);
		  					}
		  					
		  				}
		  			
		  			}
		  			
		  			that.callBackFunction = callBack;
					// console.log("mtemp.key:"+mtemp.key);
					// console.log("mtemp.cbList:"+mtemp.cbList.length);
		  			// 改变调用域 
		  			let exists = false;
		  			//			for(let m=0;m<reqList.length;m++)
		  			//			{
		  						 
		  							if(mtemp.key)
		  							{
		  								// 找到这个值
		  								
		  								exists = true;
		  								mtemp.retData = data;
		  								for(let c=0;c<mtemp.cbList.length;c++)
		  								{
		  									// console.log("huidiao:：：：mtemp.cbList:"+c);
		  									// 改变调用域 
		  									if(mtemp.cbList[c]&&mtemp.cbList[c].cb && typeof mtemp.cbList[c].cb=="function")
		  									{ 	
												if(mtemp.cbList[c].from.unmounted)
												{
													console.log("huidiao: 组件已卸载！！！" );
													continue;
												}
		  										//console.log(JSON.stringify(data));
												try{
													
													// console.log("huidiao:"+mtemp.key)
													mtemp.cbList[c].cb.call(that,JSON.parse(JSON.stringify(data)));
												}
												catch(err){
													console.log("回调时发生错误！",err);
												}
		  										
		  										 
		  										 
		  									}
		  								} 
		  								
		  								 	mtemp.cbList=[];
		  								 
		  								
		  			//					break;
		  								
		  							}
		  			//			}
		  						
		  						if(!exists)
		  						{
		  							that.callBackFunction = callBack;
		  							// 改变调用域 
		  							if(that.callBackFunction!=null&&typeof that.callBackFunction=="function")
		  							{
		  								//console.log("返回值"+JSON.stringify(data));					 
		  								that.callBackFunction.call(that,data);
		  							}
		  						} 
		  			
		  		};
		  		
		  		
		  		if(url.indexOf("keeUploadFile")!=-1)
		  		{
		  			$.ajax({
		  				url: url,
		  				type: 'POST',
		  				cache: false,
		  				data: postData,
		  				dataType: "json", 
		  				success: that.ajaxCallBack,
		  				crossDomain: true,
		  				error:  (XMLHttpRequest, textStatus, errorThrown)=> {
		  					
		  					if(this.unmounted)
		  					{
		  						return ;
		  					}
		  					console.log("请求信息："+JSON.stringify(XMLHttpRequest));
		  					
		  					if(XMLHttpRequest.status==404||XMLHttpRequest.status==403||XMLHttpRequest.status==500)
		  					{
		  						// alert(XMLHttpRequest.status+"错误，"+url);
								console.log(XMLHttpRequest.status+"错误，"+url)
		  						return ;
		  					}
		  					
		  					console.log("网络连接出错:" + textStatus + "  errorThrown:" + errorThrown);		
		  					if(textStatus == "parsererror") {
		  						 console.error("数据请求错误，请稍后重试！"+url);	
		  						//location.href = getFullUrl("/login");
		  						alert("数据请求错误，请稍后重试！!"+url);
		  						return;
		  					}
		  								
		  				}
		  			});
		  		}
		  		else
		  		{
		  			
		  			if(!existsReq)
		  			{
		  				// 创建一个
		  				mtemp = {
		  			 			key:key,
		  			 			pTime:new Date(),
		  			 			retData:'', 
		  			 			cbList:[{"from":that,"cb":callBack}],
		  			 		};
						
		  				reqList.push(mtemp)
		  			}
					
					let ajaxType = 'POST';
					let isCache = false;
					
					if(url.indexOf("keePage/getByCode")!=-1)
					{
						url = url+="&pt="+window.MAX_KEE_PAGE_TIME;
						ajaxType="GET";
						isCache = true;
						
						if(postData.appId==postData.sessionkey)
						{
							delete postData.sessionkey;
							delete postData.appId;
							
						}
						
						for(let pp in postData)
						{
							if(pp=='sessionKey'||pp.indexOf("_token")!=-1 )
							{
								delete postData[pp];
							}
						}
					}
					
					//console.log("huidiao:ajax request");
		  			$.ajax({
		  				url: url,
		  				type: ajaxType,
		  			 
						beforeSend: function(request) {
							
							
				 
								if(headers)
								{
									 request.setRequestHeader("Accept", "application/json, text/javascript, */*; q=0.01");
									 // request.setRequestHeader("Accept-Encoding", "gzip, deflate");
									 request.setRequestHeader("Accept-Language", "zh-CN,zh;q=0.9");
									 request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
									 // request.setRequestHeader("Cookie", window.document.cookie);
									 
									  
									request.setRequestHeader("Authorization", JSON.stringify(headers));
									 
									 
								}
					             
					           },
		  				
		  				cache: isCache,
		  				data: postData,
		  				dataType: "json",
		  				xhrFields: {withCredentials: true},
		  				success: that.ajaxCallBack,
		  				crossDomain: true,
						
		  				error: (XMLHttpRequest, textStatus, errorThrown)=> {
		  					if(this.unmounted)
		  					{
		  						return ;
		  					}
		  					console.log("请求信息："+JSON.stringify(XMLHttpRequest));
		  					if(XMLHttpRequest.status==404||XMLHttpRequest.status==403||XMLHttpRequest.status==500)
		  					{
		  						//alert(XMLHttpRequest.status+"错误，"+url);
								console.log(XMLHttpRequest.status+"错误，"+url);
		  						return ;
		  					}
		  					
		  					console.log("网络连接出错:" + textStatus + "  errorThrown:" + errorThrown);		
		  					if(textStatus == "parsererror") {
		  						 console.error("数据请求错误，请稍后重试！"+url);	
		  						//location.href = getFullUrl("/login");
		  						alert("数据请求错误，请稍后重试！"+url);
		  						return;
		  					}
		  								
		  				}
		  			});
		  		}
		  		 
		  
		  		
		  	}
		  
		  
		  
	  }
	//////////////////////////////////////////////////////////////////////////////////////////////////////




	getByAlias(componentArray, alias) {
		if(!componentArray)
		{
			return null;
		}
		for (let i = 0; i < componentArray.length; i++) {
			let c = componentArray[i];
			if (c.alias == alias) {
				return c;
			} else {
				if (c.child != null) {
					let ret = this.getByAlias(c.child, alias);

					if (ret != null) {
						return ret;
					}
				}
			}

		}
		return null;
	} 
	  getQueryVariable(name){
		  
		 
		  
	       let query = window.location.search.substring(1);
	       let vars = query.split("&");
	       for (let i=0;i<vars.length;i++) {
	               let pair = vars[i].split("=");
	               if(pair[0] == name){return pair[1];}
	       }
		   
		   if(window.QueryParaData && window.QueryParaData.indexOf('#')!=0)
		   {
		   	let temp = JSON.parse(window.Base64.decode(window.QueryParaData));
		   	
		   	if(temp[name])
		   	{
		   		return temp[name];
		   	}
		   }
		   
	       return(false);
	}
	openSpPage=(pageName,params)=>{
					let sp = this.getQueryVariable("sp");
					
					if(sp)
					{
						sp = sp.substring(0,sp.indexOf("/"))+"/"+pageName; 
						//this.sendEvent("openHashSp",sp);
						
						this.sendEvent("HashChange",sp,params);
						
					}
					else
					{
						alert("发送事件："+pageName);
						this.sendEvent("HashChange","2021_M::"+pageName,params);
						 
						
						// sp = window.location.hash.substring(0,window.location.hash.indexOf("/"))+"/"+pageName; 
						
						// window.location.hash=sp;
					}
				}
	openPubPage=(pageCode,params)=>{
		
		 
		
		// if(sp)
		// {
		// 	sp = sp.substring(0,sp.indexOf("/"))+"/"+pageName; 
		// 	//this.sendEvent("openHashSp",sp);
		// }
		
		let sp = "PUB_M::"+pageCode
		this.sendEvent("HashChange",sp,params);
		
	}

	findFsForm=(c,componentArray)=>{
		for(let i=0;i<componentArray.length;i++)
		{
			if(componentArray[i].name=='fs-form')
			{
				// 再看看是否包含c 组件
				if(c)
				{
					let cc = this.getComponentById(c.id,componentArray[i].child);
					if(cc)
					{
						return componentArray[i];
					}
				}
				else
				{
					return componentArray[i];
				}				
			}
			
			if(componentArray[i].child)
			{
				let form = this.findFsForm(c,componentArray[i].child);
				if(form)
				{
					return form;
				}
			}
			
		}
		return null;
	}
	
	findFsTable=(c,componentArray,tableArray)=>{
		for(let i=0;i<componentArray.length;i++)
		{
			if(componentArray[i].name=='fs-table')
			{ 
				tableArray.push(componentArray[i]);
					 
				 
			}
			
			if(componentArray[i].child)
			{
				  this.findFsTable(c,componentArray[i].child,tableArray); 
			} 
		}
		return null;
	}
	

	getComponentById=(id, fromComponents)=> {
				if(fromComponents)
				{
					for(let i = 0; i < fromComponents.length; i++) {
						let c = fromComponents[i];
						if((c.id&&c.id === id)||(c.key&&c.key===id)) {
							return c;
						}
						if(!c.child)
						{
							c.child = c.children; 
						}
						if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
							let target = this.getComponentById(id, c.child);
							if(target )
								return target;
						}
					}
				}
				
				return null;
			}


	getComponentParentById=(id,parent, fromComponents)=> {
				if(fromComponents)
				{
					for(let i = 0; i < fromComponents.length; i++) {
						let c = fromComponents[i];
						if((c.id&&c.id === id)||(c.key&&c.key===id)) {
							return parent;
						}
						if(!c.child)
						{
							c.child = c.children;
							 
						}
						
						if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
							let target = this.getComponentParentById(id, c, c.child);
							if(target )
								return target;
						}
					}
				}
				
				return null;
			}

			removeFromArray=(component, fromComponents)=> {
				if(!component)
				{
					return ;
				}
				// if(fromComponents.indexOf(component) !== -1) {
				// 	console.log("删除组件" + component.title);
				// 	fromComponents.remove(component);
				// } else 
				{
					for(let i = 0; i < fromComponents.length; i++) {
						let c = fromComponents[i];
						if((c.id&&c.id === component.id)||(c.key&&c.key===component.key)) {
							fromComponents.remove(c);
							//console.log("删除组件" + c.title);
							return;
						}
						
						if(!c.child)
						{
							c.child = c.children;
							 
						}
						
						if(typeof c.child !== "undefined" && c.child  && c.child.length > 0) {
							this.removeFromArray(component, c.child);
						}
						if( c.children   ) {
							this.removeFromArray(component, c.children);
						}
					}
				}
			}


	// 采用全部方式发送事件，尽量不要采用

	sendPageEvent(eventName, obj1, obj2, obj3, obj4, obj5, obj6) {
		this.sendViewEvent(eventName, obj1, obj2, obj3, obj4, obj5, obj6);
	}

	sendViewEvent(eventName, obj1, obj2, obj3, obj4, obj5, obj6) {
		// 在view级别发送事件，避免事件混乱
		
		if(this.props.component != null && this.isNotBlank(this.props.component.alias)&&window.CReactMap[this.props.component.viewName]) {
			console.log("this.props.component.viewNamereact:"+this.props.component.viewName+" 事件："+this.props.component.alias + "." + eventName);
			window.CReactMap[this.props.component.viewName].$emit(this.props.component.alias + "." + eventName, obj1, obj2, obj3, obj4, obj5, obj6);
		} else {
			console.log("页面加载失败，请检查页面地址是否准确！");
		}
	}


	getHashParam() {

		let hash = window.location.hash;
		// hash 为 #xxx 格式

		hash = hash.replace('#', '');

		let newHash = "";

		let targetView = "::";

		if (this.props.component != null) {
			if (this.props.component.parentView != null && this.props.component.parentView != '') {
				targetView = this.props.component.parentView;
			}

			if (this.props.component.cp.targetView != null && this.props.component.cp.targetView != '') {
				targetView = this.props.component.cp.targetView
			}
		}

		let hashes = hash.split("|"); {

			for (let i = 0; i < hashes.length; i++) {
				if (hashes[i].indexOf(targetView + "::") == 0) {

					if (hashes[i].indexOf("!routerjson=") != -1) {
						//alert("ddddddddddddddddddddd::"+hashes[i].substring(hashes[i].indexOf("!routerjson=")).replace("!routerjson=",""))
						return hashes[i].substring(hashes[i].indexOf("!routerjson=")).replace("!routerjson=", "");
					}
				}

			}
		}
	}
	
	log(...obj) {
		let name = "-";
		
		let alias = "-";
		
		if(this.props.component)
		{
			name = this.props.component.name;
			alias = this.props.component.alias;
		}
		console.log(this.state.randId+"组件："+name+"别名："+alias ,...obj); 
	}
	
	

	registComponent() {


		let that = this;


		if (this.props.component && this.props.component.alias) {
			
			// 注册刷新事件 this.props.po.id+"-"+this.props.po.alias+".render"
			this.onEvent(this.props.component.id+"-"+this.props.component.name+".render",()=>{
				
				//alert("childRefresh");
				//this.log("响应事件："+this.props.component.id+"-"+this.props.component.alias+".render")
				   // this.$emit("childRefresh")
					//this.setState(this.state);
				
				
			})
			
			//window.CReactMap[this.props.component.alias] = this;
			this.component = this.props.component;
			// alert("注册" + this.props.component.viewName + " " +
			// this.props.component.alias)
			 let rowalias="";
								 if(this.component.rowid)
								 {
									 rowalias = this.component.rowid;
								 }
								
						
						
			if (this.props.component.viewName  && window.CReactMap[this.props.component.viewName] ) {
				// console.log("注册" + this.component.viewName + " " + this.component.alias+ " "+rowalias)
				// console.log("注册||| " + this.props.component.name + " ::" + this.props.component.viewName + " " + this.props.component
				// 	.alias);
				//window.CReactMap[this.props.component.viewName]  = this;
				// window.CReactMap[this.props.component.viewName].viewer=this;
				// window.CReactMap[this.props.component.viewName].viewer[this.props.component.alias] = this;
				
				if(!window.CReactMap[this.component.viewName].viewer)
				{
					window.CReactMap[this.component.viewName].viewer = {};
				}
				
				if(window.CReactMap[this.component.viewName][this.component.alias+rowalias])
				{
					// 已存在，再看看是否是系统属性，如果不是则可以替换
					
					if(!window.CReactMap[this.component.viewName].viewer[this.component.alias+rowalias])
					{
						console.log("组件唯一标识与系统属性名冲突，不能使用！"+this.component.alias+rowalias)
						return ;
					}
					
				}
				
				window.CReactMap[this.component.viewName].viewer[this.component.alias+rowalias] = this;
				window.CReactMap[this.component.viewName][this.component.alias+rowalias] = this;
				
				// window.CReactMap[this.props.component.viewName][this.props.component.alias] = this;
				
				// 已存在
				if(window.CReactMap[this.props.component.viewName][this.props.component.alias])
				{
					// 已存在，重置覆盖！
					window.CReactMap[this.props.component.viewName][this.props.component.alias] = this;
					if(!window.CReactMap[this.props.component.viewName][this.props.component.alias].rowComponentItem)
					{
						window.CReactMap[this.props.component.viewName][this.props.component.alias].rowComponentItem={};
					}
					window.CReactMap[this.props.component.viewName][this.props.component.alias].rowComponentItem[rowalias] = this;
				}
				else
				{
					window.CReactMap[this.props.component.viewName][this.props.component.alias] = this;
					window.CReactMap[this.props.component.viewName][this.props.component.alias].rowComponentItem={};
					window.CReactMap[this.props.component.viewName][this.props.component.alias].rowComponentItem[rowalias] = this;
				}
									
			}
			 
			if (typeof window.CReactMap.components == "undefined" || window.CReactMap.components == null) {
				window.CReactMap.components = {};
			}

			window.CReactMap.components[this.props.component.name] = this.props.component.name;

		}




		if (typeof this.getHashParam != "undefined" && (!this.$route)) {
			let str = this.getHashParam();
			if (str) {
				let query = JSON.parse(window.Base64.decode(str));
				this.$route = {};
				this.$route.query = query;
				
				for(let pp in query)
				{
					query[pp]=decodeURIComponent(query[pp]);
				}
				
			} else {
				this.$route = {};
				this.$route.query = {};
			}
		}

	}

	// 响应事件,必须先移除事件，否则会重复响应事件
	// 如果有需要多个响应的事件，则会造成冲突，需要取一个名字，target
	// 也可以是上一个对象的this+this.$options.templatethis.$options.template指针，这样避免名字太多，容易重复等问题
	// 


	/**
	 * 打开图层
	 */

	/**
	 * 通用型显示窗口
	 */
	showWindow(obj) {
		let that = this;
		this.sendEvent('showWindow', obj);

	}

	showFeasDialog(title, id, dialogTitle) {

		//alert("showFeasDialog:"+title)

		this.sendEvent('showWindow', {
			target: 'dialog',
			url: title,
			feasName: title,
			title: dialogTitle,
			dialogTitle: dialogTitle,
			data: {
				id: id
			},
			callback() {

			}
		});

		this.sendEvent("feasDialog.open", title, id, dialogTitle);
	}

	showDialogByUrl(url, para) {
		let that = this;

		//alert("调用showDialogByUrl");

		this.openDialog({
			dialogTitle: '',
			type: 'dialog',

			size: 's1',
			url: url,
			para: para
		})

	}

	// 打开底部窗口
	openBottom(url) {
		this.sendEvent('bottomDetail.open', url);
	}

	openDetail(url, params) {
		//alert("dd")
		this.sendEvent('showDetail', url, params);
	}

	openDialog(config) {
		// title，由内部页面进行决定

		this.sendEvent('showDialog', config);

	}

	showComponent(alias) {
		
		if(!alias)
		{
			if(this.props.component)
			{
				this.props.component.visiable = true; 
				
				return ;
			}
		}
		

		let coms = this.components;
		if (typeof alias == "undefined" || alias == null) {
			alias = this.props.component.alias;
			coms = window.CReactMap[this.props.component.viewName].components;
		}

		let cp = this.getByAlias(coms, alias);

		if (cp != null) {
			cp.visiable = true;
		} else {
			alert(alias + "组件未找到！！！")
		}
	}
	hideComponent(alias) {
		
		if(!alias)
		{
			if(this.props.component)
			{
				this.props.component.visiable = false; 
				
				return ;
			}
		}

		let coms = this.components;
		if (typeof alias == "undefined" || alias == null) {
			alias = this.props.component.alias;
			coms = window.CReactMap[this.props.component.viewName].components;
		}

		let cp = this.getByAlias(coms, alias);

		if (cp != null) {
			cp.visiable = false;
		} else {
			alert(alias + "组件未找到！！！")
		}
	}

	// 新的打开方式
	// 以对话框形式打开页面
	openDlgPage(url, data) {
		if(!this.targetApp)
		{
			this.targetApp = window.appName;
		}
		this.sendEvent("win.open", {
			target: 'dialog',
			url: url,
			data: data,
			appCode: this.targetApp,
		});
	}
	// 以右侧滑出的方式打开页面
	openRightPage(url, data) {
		if(data)
		{
			data.size="";
		}
		if(!this.targetApp)
		{
			this.targetApp = window.appName;
		}
		this.sendEvent("win.open.react", {
			target: 'right',
			url: url,
			data: data,
			appCode: this.targetApp,
		});
	}
	// 以右键菜单形式打开
	openRightMenu(url, data) {
		if(!this.targetApp)
		{
			this.targetApp = window.appName;
		}
		this.sendEvent("win.open.react", {
			target: 'menu',
			url: url,
			data: data,
			appCode: this.targetApp,
		});
	}
	// 以底部滑出的方式打开页面
	openBottomPage(url, data) {
		 
		if(!this.targetApp)
		{
			this.targetApp = window.appName;
		}
		this.sendEvent("win.open", {
			target: 'bottom',
			url: url,
			data: data,
			appCode: this.targetApp,
		});
	}

	// 做一个默认的激活动作
	activeFormPage(that, params) {
		
		let form=that.findFsForm(null,that.components);
		
		if(form)
		{
			
			that[form.alias].setDialogConfig(params);
			if(params)
			{
				console.log("设置form的额外参数");
				that[form.alias].extraParas = params.extraParas; 
				that.caller = params; 
			}
			
			
			if (params&&this.isNotBlank(params.loadUrl)  ) { 
				that[form.alias].resetForm();
				this.doRequest(params.loadUrl,
					function(ret) {
						if (ret.id != null  ) {
							that[form.alias].showData(ret);
						}
					})
			}
			
		}
		else
		{
			// 响应激活时的动作
			if (params != null) {
			
				if (this.isNotBlank(params.loadUrl) && that.form0 != null) {
			
					that.form0.extraParas = params.extraParas;
			
					that.caller = params;
			
					//that.form0.resetForm();
					that.form0.setDialogConfig(params);
					this.doRequest(params.loadUrl,
						function(ret) {
							if (ret.id != null && that.form0 != null) {
								that.form0.showData(ret);
							}
						})
			
				} else {
			
					//console.log(that);
					//alert(that.component.name+" : "+that.component.alias);
					console.log("loadUrl 为空，或 没有名称为form0的表单组件！")
				}
			} else {
				console.log("参数为空active")
			}
		}

		
	}

	//			openRight(url) {
	//
	//				this.sendEvent('rightDetail.open', url);
	//			},
	closeRight() {

		this.sendEvent('rightDetail.close');
	}

	formatterDay(value) {
		// vue 的formatter问题
		return this.formatterDate(value, 'yy-MM-dd');
	}
	formatterTime(value) {
		// vue 的formatter问题
		return this.formatterDate(value, 'yyyy-MM-dd hh:mm:ss');
	}
	compare(prop) {
		return function(obj1, obj2) {
			let val1 = this.getValueByAttr(obj1, prop);
			let val2 = this.getValueByAttr(obj2, prop);
			if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
				val1 = Number(val1);
				val2 = Number(val2);
			}
			if (val1 < val2) {
				return -1;
			} else if (val1 > val2) {
				return 1;
			} else {
				return 0;
			}
		}
	}

	getSelectComponentId(event) {

		let target = event.target;

		let tid = event.target.getAttribute("tid");

		if (tid == null) {
			let parent = event.target.parentNode;
			while (parent != null && typeof parent.getAttribute == "function") {

				tid = parent.getAttribute("tid");

				if (tid != null) {
					return parent
					break;
				} else {
					parent = parent.parentNode;
				}
			}
		} else {
			return event.target;
		}

		return null;

	}
	getComponentByAlias=(componentArray, aliasName)=> {
				if(componentArray ) {
					for(let i = 0; i < componentArray.length; i++) {
						let c = componentArray[i];
						if(c.alias === aliasName) {
							return c;
						}
						if(c.child ) {
							let ret = this.getComponentByAlias(c.child, aliasName);
							if(ret)
								return ret;
						}
					}
					return false;
				}
				return false;
			}
	/**
	 * 将原始组件的值，根据配置，设置默认的值，否则vue不会绑定
	 * @param {Object} componentArray
	 * @param {Object} data
	 */
	convertComponent(componentArray, data) {

		for (let i = 0; i < componentArray.length; i++) {
			let c = componentArray[i];

			// 这个地方的rowid 有什么用
			//					c.rowid = this.keePage.id;
			//					console.log("c.rowid=" + this.keePage.id);

			if (this.isNotBlank(c.alias) == false)
				c.alias = c.id;

			if (this.isNotBlank(c.permission) == false)
				c.permission = "";
			// 默认可见状态	
			c.visiable = true;
			// 是否在移动中
			c.isMoving = false;

			// 是否被选中，activeComponent.id
			c.isSelected = false;

			c.isKeeShowBorder = false;
 c.isMouseOver=false;
			// 构建默认值 
			//					if(this.isNotBlank(c.cp.showExpression)) {
			//						c.visiable = false;
			//
			//					} else {
			//						c.visiable = true;
			//					}
			//console.log(">>>>>>>>>>> p:" + JSON.stringify(c.style));
			//					for(let p in c.style) {
			//						console.log(">>>>>>>>>>> p:" + p + " " + c.style[p])
			//
			//						//					if(this.isNotBlank(c.style[p])&& (p == 'left' || p == 'top' || p == 'width' || p == 'height' || p == 'bottom' || p == 'right' || p.indexOf("Left") != -1 || p.indexOf("Top") != -1)) {
			//						//						c.style[p] = c.style[p] + "px";
			//						//							 
			//						//					}
			//
			//						console.log(">>>>>>>>>>> p:" + p + " " + c.style[p])
			//
			//						// 驼峰方式转横线连接方式？
			//					}

			// 默认关闭

			c.showChild = false;

			//					console.log(c.name + "设置c.alias:::::::::::::::::::::::::::" + c.alias);

			if (typeof c.child != "undefined" && c.child != null && c.child.length > 0) {
				this.convertComponent(c.child, data);
			}

			for (let t = 0; t < data.fields.length; t++) {
				let field = data.fields[t];

				if (!this.isNotBlank(field.field)) {
					continue;
				}

				let defaultValue = null;

				if (this.isNotBlank(field.map.defaultValue)) {
					if (field.type == "switch") {
						if (field.map.defaultValue == "true")
							defaultValue = true;
						if (field.map.defaultValue == "false")
							defaultValue = false;
					} else {

						if (field.type == 'text' && 'number' == field.map.format && this.isNotBlank(field.map.defaultValue)) {
							defaultValue = parseInt(field.map.defaultValue);
						} else {
							defaultValue = field.map.defaultValue;
						}

					}
				}
				// 不为空才设置表单配置的默认值
				if (this.getValueByAttr(c, field.field) == null) {
					this.setAttr(c, field.field, defaultValue);
				}

			}

		}
	}
	initComponentByFormField(c, data) {
		if (data == null)
			return;
		for (let i = 0; i < data.fields.length; i++) {
			let field = data.fields[i];

			if (!this.isNotBlank(field.field)) {
				continue;
			}

			let defaultValue = null;

			if (this.isNotBlank(field.map.defaultValue)) {
				if (field.type == "switch") {
					if (field.map.defaultValue == "true")
						defaultValue = true;
					if (field.map.defaultValue == "false")
						defaultValue = false;
				} else {
					if (field.type == 'text' &&
						'number' == field.map.format &&
						this
						.isNotBlank(field.map.defaultValue)) {
						defaultValue = parseInt(field.map.defaultValue);
					} else {
						defaultValue = field.map.defaultValue;
					}
				}
			}
			// 不为空才设置表单配置的默认值
			if (this.isNotBlank(this.getValueByAttr(c, field.field)) != true) {
				this.setAttr(c, field.field, defaultValue);
			}

		}
	}

	initPageComponent(componentArray, viewName) {

		for (let i = 0; i < componentArray.length; i++) {
			let c = componentArray[i];

			// 设置组件的验证等辅助信息
			c.errorMsg = "";
			c.error = false;

			c.viewName = viewName;
			
			if(c.cp.disabled!==true&&c.cp.disabled!==false)
			{
				c.cp.disabled = false;
			}

			c.parentView = this.parentView;

			if (this.isNotBlank(c.cp.visiable)) {
				if (c.cp.visiable == true || c.cp.visiable == 'true') {
					c.visiable = true;
				} else {
					c.visiable = false;
				}
			} else {
				c.visiable = true;
			}

			c.isSelected = false;

			c.isKeeShowBorder = false;
 c.isMouseOver=false;
			// 给rowid赋予一个默认值，否则vue不会自动绑定
			c.rowid = 0;

			// 这个值必须要清空
			c.templateForm = null;

			// 构建默认值 
			/*if(this.isNotBlank(c.cp.showExpression)) {
	
							c.visiable = false;
	
						} else {
							c.visiable = true;
						}*/

			if (this.isNotBlank(c.alias) == false)
				c.alias = c.id;
			c.hasPermission = true;
			if (this.isNotBlank(c.permission)) {
				c.hasPermission = false;
				let permissions = c.permission.split(",");
				for (let n = 0; n < permissions.length; n++) {
					if (this.isNotBlank(permissions[n]) && this.isNotBlank(window.userPermissions[permissions[n]])) {
						c.hasPermission = true;
						break;
					}
				}
				if (c.hasPermission == false) {
					c.visiable = false;
				}
			}

			if (this.isNotBlank(c.cp.modelName)) { // 要设置一个值

				this.$set(this.query, c.cp.modelName, c.value);
				//this.setAttr(this.query,c.cp.modelName,c.value);
			}

			if (this.po != null && this.isNotBlank(c.cp.field)) { // 要设置一个值

				if (this.getValueByAttr(this.po, c.cp.field) == null) {
					if (c.name == 'fs-table') {
						this.setVueAttr(this.po, c.cp.field, []);
					} else {
						this.setVueAttr(this.po, c.cp.field, null);
					}

				}

			}

			if (typeof c.child != "undefined" && c.child != null && c.child.length > 0) {
				this.initPageComponent(c.child, viewName);
			}
		}
	}

	getDictTitle(value, dictTypeName) {
		if (value == null)
			return '';
		for (let i = 0; i < window.allDicts.length; i++) {
			if (window.allDicts[i].dictTypeName == dictTypeName && (window.allDicts[i].name == value || (value == true &&
					window.allDicts[i].name == "true") || (value == false && window.allDicts[i].name == "false"))) {
				return window.allDicts[i].title;
			}
		}
	}

	getDate(value, formatter) {
		if (value == null || value == "")
			return "";
		//console.log(value);
		if (formatter == null) {
			return this.formatterDate(value, "yyyy-MM月dd");
		} else {
			return this.formatterDate(value, formatter);
		}

	}
	
	toTuoFeng(targetString) {
	        return targetString.replace(/\_(\w)/g,function(match,letter) {
	            console.log(match,letter) 
	            // _s  s
	            // _f   f
	            return letter.toUpperCase()
	        })
	}



	getPageParam() {

		let hash = window.location.hash;
		// hash 为 #xxx 格式

		hash = hash.replace('#', '');



		if (hash.indexOf("!routerjson=") != -1) {
			//alert("ddddddddddddddddddddd::"+hashes[i].substring(hashes[i].indexOf("!routerjson=")).replace("!routerjson=",""))
			return hash.substring(hash.indexOf("!routerjson=")).replace("!routerjson=", "");
		}

	}

	// 打开一个页面,用于打开后台页面
	openAppPage(pageName, query) {
		let hash = window.location.hash;
		// hash 为 #xxx 格式 
		hash = hash.replace('#', '');
		let newHash = "";

		if (hash.indexOf("/") != -1) {
			newHash = hash.substring(0, hash.indexOf("/")) + "/" + pageName;
		}

		if (query != null) {
			newHash += "!routerjson=" + window.Base64.encode(JSON.stringify(query));
		}

		//location.href="#"+newHash;

		this.openSp(newHash);

		window.scrollTo(0, 0)

	}

	validValue(item) {

		// 验证用户输入的值是否符合要求；

		let error = false;
		let errorMsg = "";

		if (item.type == "dateRange") {
			if (item.cp.required != null && item.cp.required == true) {

				//alert(JSON.stringify(item.value));

				let str = JSON.stringify(item.value);

				if (str.length < 26 || str.indexOf("N") != -1) {
					error = true;
					errorMsg = "必填项";
				}
			}
		} else {
			if (item.cp.required != null && item.cp.required == true) {
				if (this.isNotBlank(item.value) != true) {
					error = true;
					errorMsg = "必填项";
				}
			}
		}

		if (item.cp.format != null && item.cp.format != "") {
			if (item.cp.format == "text") {

			}
			if (item.cp.format == "email" && item.value != null && item.value != "" && this.isEmail(item.value) == false) {
				error = true;
				errorMsg = "邮箱格式错误";
			}
			if (item.cp.format == "phone" && item.value != null && item.value != "" && this.isPhone(item.value) == false) {
				error = true;
				errorMsg = "电话格式错误";
			}
			if (item.cp.format == "tel" && item.value != null && item.value != "" && this.isTel(item.value) == false) {
				error = true;
				errorMsg = "手机号格式错误";
			}
			if (item.cp.format == "idcard" && item.value != null && item.value != "" && this.isIdCard(item.value) == false) {
				error = true;
				errorMsg = "身份证格式错误";
			}
			if (item.cp.format == "ip" && item.value != null && item.value != "" && this.isIp(item.value) == false) {
				error = true;
				errorMsg = "IP格式错误";
			}
			if (item.cp.format == "number" && item.value != null && item.value != "" && this.isNumber(item.value) == false) {
				error = true;
				errorMsg = "只能输入数字";
			}
			if (item.cp.format == "float" && item.value != null && item.value != "" && this.isFloat(item.value) == false) {
				error = true;
				errorMsg = "只能输入小数";
			}
			if (item.cp.format == "int" && item.value != null && item.value != "" && this.isInt(item.value) == false) {
				error = true;
				errorMsg = "只能输入正整数";
			}

		}

		if (item.cp.minLength != null && item.cp.minLength != "") {
			if (item.value != null && item.value.length < parseInt(item.cp.minLength)) {
				error = true;
				errorMsg += "输入长度最小为" + item.cp.minLength + "个字符";
			}
		}
		if (item.cp.maxLength != null && item.cp.maxLength != "") {
			if (item.value != null && item.value.length > parseInt(item.cp.maxLength)) {
				error = true;
				errorMsg += "输入长度最大为" + item.cp.maxLength + "个字符";
			}
		}

		if (item.cp.format == 'number' || item.cp.format == 'float' || item.cp.format == 'int') {
			if (this.isNotBlank(item.cp.min)) {
				if (item.value != null && parseInt(item.value) < parseInt(item.cp.min)) {
					error = true;
					errorMsg += "不能小于值" + item.cp.min + "";
				}
			}

			if (this.isNotBlank(item.cp.max)) {
				if (item.value != null && parseInt(item.value) > parseInt(item.cp.max)) {
					error = true;
					errorMsg += "不能大于值" + item.cp.max + "";
				}
			}
		}

		// 读取数据库系统的验证条件，待完善；

		// 验证长度

		// 验证格式

		item.error = error;
		item.errorMsg = errorMsg;

	}



		selfSetIcon(url){
			let links = document.getElementsByTagName('link') // 獲取所有 link 元素
			for (let i = 0; i < links.length; i++) { //遍歷 link 元素
				let link = links[i]
				let rel = link.rel; // rel 表示 link 的類型  icon 對應 shortcut icon
				rel = rel.toLowerCase(); // 部分網站 會 大寫. 統一轉成小寫
				if (rel.indexOf('icon') > -1) { // 當連接中存在 shortcut icon 字眼
					link.href = url // 修改 網站icon
					break;
				}
			}
		}
	
 
	  loadJs(url,callback){
		 let script=document.createElement('script');
		 script.type="text/javascript";
		 if(typeof(callback)!="undefined"){
		 if(script.readyState){
		 script.onreadystatechange=function(){
		  if(script.readyState == "loaded" || script.readyState == "complete"){
		  script.onreadystatechange=null;
		  callback();
		  }
		 }
		 }else{
		 script.onload=function(){
		  callback();
		 }
		 }
		 }
		 script.src=url;
		 document.body.appendChild(script);
	 }
	 
	 loadCss(url,callback){
	 		 let script=document.createElement('style');
	 		 script.type="text/css";
	 		 if(typeof(callback)!="undefined"){
	 		 if(script.readyState){
	 		 script.onreadystatechange=function(){
	 		  if(script.readyState == "loaded" || script.readyState == "complete"){
	 		  script.onreadystatechange=null;
	 		  callback();
	 		  }
	 		 }
	 		 }else{
	 		 script.onload=function(){
	 		  callback();
	 		 }
	 		 }
	 		 }
	 		 script.src=url;
	 		 // document.body.appendChild(script);
			 document.getElementsByTagName("head")[0].appendChild(script);
	 }




	loadPageComponents(names, callback) {

		if (names != "") {
			// 看看是否已加载

			let cs = names.split(",");

			for (let j = 0; j < cs.length; j++) {
				if (window.installedComponent[cs[j]] == cs[j]) {
					names = ("," + names + ",").replace("," + cs[j] + ",", ",");
				}
			}

			while(names.indexOf(",,")!=-1)
				{
					names = names.replace(",,","");
				} 
		}
			 
			if(!names)
			{
				callback();
				return ;
			}
		
		let protocolStr = document.location.protocol;
		if(protocolStr == "https:")
		{ 
		   window.rootUri = window.rootUri.replace("http://","https://");
		}
		

		if (names.length > 1) {
			$.ajax({
				url: window.rootUri + "/api/vueComponentJs/getByCombineBusinessJsWithNames?names=" + names,
				cache: true,
				type: 'get',
				dataType: "html",
				data: {},
				success: function(str) {



					let oHead = document.getElementsByTagName('HEAD').item(0);
					let oScript = document.createElement("script");
					// "text/javascript"
					oScript.type = "text/javascript";
					oScript.text = str;
					oHead.appendChild(oScript);
					
					let protocolStr = document.location.protocol;
					if(protocolStr == "https:")
					{ 
					   window.rootUri = window.rootUri.replace("http://","https://");
					}

					$.ajax({
						url: window.rootUri + "/api/vueComponentJs/getByCombineBusinessCssWithNames?names=" + names+"&withScope=true" ,
						cache: true,
						type: 'get',
						dataType: "html",
						data: {},
						success: function(str) {
							let nod = document.createElement("style");
							nod.type = "text/css";
							if (nod.styleSheet) { //ie下  
								nod.styleSheet.cssText = str;
							} else {
								nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
							}
							document.getElementsByTagName("head")[0].appendChild(nod);

							let cs = names.split(",");

							for (let j = 0; j < cs.length; j++) {
								window.installedComponent[cs[j]] = cs[j];
							}

							callback();
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {
							console.log("设置值错误：" + module.url);
							console.log("网络请求错误")
							module.data = "";
						}
					});


				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					console.log("设置值错误：" + module.url);
					console.log("网络请求错误")
					module.data = "";
				}
			});
		} else {
			callback();
		}






	}




















	/* 以前kee-base 里面KeeUtils的内容*/

	each(obj, callback) {
		if (obj) {
			$.each(obj, callback);
		}
	}

	isNotBlank(obj) {
		if (typeof obj == 'undefined' || obj == null ||
			(typeof obj == 'string' && obj.trim() == "")) {
			return false;
		} else
			return true;
	}
	// 获取随机数
	getRandString() {
		let randId = "rand";
		for (let i = 0; i < 10; i++) {
			randId += parseInt(Math.random() * (100));
		}
		//console.log("生成随机数："+randId);
		return randId;
	}
	formatterDate(value, type) {
		return window.formatterDate(value, type);
	}
	// 通过系统定义的默认验证规则，生成Vue组件的表单验证规则，兼容以前的写法
	getValidRule(formItem, entityName) {
		if (entityName != null && window.KeeEntity[entityName] &&
			window.KeeEntity[entityName][formItem.field] != null) {
			let valid = window.KeeEntity[entityName][formItem.field].valid;
			console.log("2找到实体：", formItem.field, valid);
			if (valid != null) {
				if (formItem.valid == null)
					formItem.valid = {};
				if (formItem.valid == 'required') {
					formItem.valid = {
						required: true
					};
				}
				// 继承
				formItem.valid = $.extend(valid, formItem.valid);
			}

		} else {

			if (formItem.valid == null) {
				formItem.valid = {};
			}
			if (formItem.valid == 'required') {
				formItem.valid = {
					required: true
				};
			}

			if (formItem.field.indexOf("map.") == 0 ||
				formItem.field.indexOf("map_") == 0) {

				// 最多6000个字
				formItem.valid = $.extend({
					maxlength: 6000
				}, formItem.valid);

			}

		}
	}
	getAttr(object, field) {
		return this.getValueByAttr(object, field);
	}
	getValueByAttr(object, field) {
		let realValue = object;
		if (field == null)
			return;
		if (field.indexOf('map_') == 0) {
			field = field.replace(/_/g, ".");
		}

		let fields = field.split(".");
		let yiChuLiField = "";
		for (let i = 0; i < fields.length; i++) {

			let p = fields[i];
			if (p != null && p.trim() != '') {
				if (realValue != null) {
					// 如果是数组怎么处理
					realValue = realValue[p];
					/*
					 * if(realValue instanceof Array && i<fields.length-1) { //
					 * 创建一个新的array,取它的子数据回来 let retArray = new Array();
					 * 
					 * for(let j=0;j<realValue.length;j++) {
					 * retArray.push(getValueByAttr(realValue[j],field.replace(yiChuLiField,""))); }
					 * 
					 * return retArray; }
					 */
				}
			}
		}

		return realValue;
	}


	setVueAttr(object, field, value) {
		//console.log("vue方式设置值方式："+field+" "+value);
		if(object!=null)
		{
			window.setVueAttr(object, field, value);
		}
		
		this.setAttr(object, field, value); 
			
	
	  
		
	}

	setAttr(object, field, value) {
		//console.log("目标对象：", object, field, value);
		if (!object) {
			return;
		}
		if (!field) {
			return;
		}
		let realValue = object;
		let fields = field.split(".");
		for (let i = 0; i < fields.length; i++) {
			let p = fields[i];

			if (i == (fields.length - 1)) {
				realValue[p] = value;
			} else {
				if (realValue[p] == null) {
					realValue[p] = {};
				}
				realValue = realValue[p];
			}
			if (realValue == null) {
				return;
			}

		}

	}
	
	
		listToTree(oldArr) {
	        let ind=0;
			oldArr.forEach(element =>{
	
				let parentId = element.fid;
				
				element.isRootRootOrg = true;
				element.cid = element.id;
				
				//alert(element.key);
	
				if (parentId) {
	
					oldArr.forEach(ele =>{
	
						if (ele.id == parentId) { //当内层循环的ID== 外层循环的parendId时，（说明有children），需要往该内层id里建个children并push对应的数组；
							ele.key = "key"+ele.id+ind+ind++;
							if (!ele.children) {
	
								ele.children = [];
	
							}
							
							element.isRootRootOrg = false;
							
							//	alert("shanchu:"+element.name);
	
							ele.children.push(element);
	
						}
	
					});
	
				}
	
			});
			
		 
			
			for(let i=0;i<oldArr.length;i++)
			{
			    if(!oldArr[i].isRootRootOrg)
			    {
			        // 剔除掉
			       // alert("shanchu:"+oldArr.length);
			        oldArr.remove(oldArr[i]);
			        // alert("shanchu:"+oldArr.length);
			     //  console.log("shanchu:"+oldArr.length);
			        i--;
			    }
			} 
		//	this.setKey(oldArr,0);
		}
		

	// http://tool.oschina.net/regex/ 在线检测验证工具，去掉前面的 /



	isTel(value) {
		return (/^(?:1\d)-?\d{6}(\d{3}|\*{3})$/.test($.trim(value)));
	}

	isPhone(value) {
		// "兼容格式: 国家代码(2到3位)-区号(2到3位)-电话号码(7到8位)-分机号(1-4位)"
		return (/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}(-\d{1,4})?$/.test($
			.trim(value)));
	}
	isTelMobile(value) {

		return (
			/^(([0\+]\d{2,3}-)?(0\d{2,3}\-)?([2-9]\d{6,7})+(\-\d{1,4})?|(?:13\d|15[012356789]|18[0256789]|147)-?\d{5}(\d{3}|\*{3}))?$/
			.test($.trim(value)));
	}
	isIdCard(IdCard) {
	var reg = /^\d{15}(\d{2}[0-9X])?$/i;
    		if(!reg.test(IdCard)) {
    			return false;
    		}
            var areaCode=IdCard.substr(0,1);
            console.log("地区码第一位",areaCode);
            if(parseInt(areaCode)==0||parseInt(areaCode)==9)
            {
               console.log("地区码第一位不符合规范");
               return false;
            }
    		if(IdCard.length == 15) {
    			var n = new Date();
    			console.log("now",n.format("yyyyMMdd"));
    			var y = n.getFullYear();
    			console.log("啦啦啦",typeof y);
    			if(parseInt("19" + IdCard.substr(6, 2)) < 1900 ||
    				parseInt("19" + IdCard.substr(6, 2)) > y) {
    				return false;
    			}

//    			var birth = "19" + IdCard.substr(6, 2) + "-" + IdCard.substr(8, 2) +
//    				"-" + IdCard.substr(10, 2);
                var birth="19" + IdCard.substr(6, 2) + IdCard.substr(8, 2) + IdCard.substr(10, 2);
                console.log("出生日期",birth)
                if(!this.isDate(birth))
                {
                    console.log("15位的身份证号日期不符合规范",birth);
                    return false;
                }
//    			if(!Common.IsDate(birth)) {
//    				return false;
//    			}
    		}
    		if(IdCard.length == 18) {
    			var n = new Date();
    			var y = n.getFullYear();
    			if(parseInt(IdCard.substr(6, 4)) < 1900 ||
    				parseInt(IdCard.substr(6, 4)) > y) {
    				return false;
    			}

//    			var birth = IdCard.substr(6, 4) + "-" + IdCard.substr(10, 2) + "-" +
//    				IdCard.substr(12, 2);
                var birth = IdCard.substr(6, 4)  + IdCard.substr(10, 2) +IdCard.substr(12, 2);
                console.log("出生日期",birth)
                if(!this.isDate(birth))
                {
                    console.log("18位的身份证号日期不符合规范",birth);
                    return false;
                }
//    			if(!Common.IsDate(birth)) {
//    				return false;
//    			}

    			var iW = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
    				1);

    			var iSum = 0;
    			for(var i = 0; i < 17; i++) {
    				var iC = IdCard.charAt(i);
    				var iVal = parseInt(iC);
    				iSum += iVal * iW[i];
    			}

    			var iJYM = iSum % 11;
    			var sJYM='';
    			if(iJYM == 0)
    				sJYM = "1";
    			else if(iJYM == 1)
    				sJYM = "0";
    			else if(iJYM == 2)
    				sJYM = "x";
    			else if(iJYM == 3)
    				sJYM = "9";
    			else if(iJYM == 4)
    				sJYM = "8";
    			else if(iJYM == 5)
    				sJYM = "7";
    			else if(iJYM == 6)
    				sJYM = "6";
    			else if(iJYM == 7)
    				sJYM = "5";
    			else if(iJYM == 8)
    				sJYM = "4";
    			else if(iJYM == 9)
    				sJYM = "3";
    			else if(iJYM == 10)
    				sJYM = "2";

    			var cCheck = IdCard.charAt(17).toLowerCase();
    			if(cCheck != sJYM) {
    				return false;
    			}
    		}
    		return true;
//		return (/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|[X|x])$/.test($
//			.trim(value)));
	}
	isDate(date)
	{
	        var now=new Date().format("yyyyMMdd");

	        if(parseInt(date)>parseInt(now))
	        {
	            console.log("日期大于当前时间",parseInt(date),parseInt(now));
	            return false;
	        }
	        var year=parseInt(date.substring(0,4));
            var month=parseInt(date.substring(4,6));
            var day=parseInt((date.substring(6,8)));
            if(month<1||month>12)
            {
                console.log("月份不符合规范");
                return false;
            }
            //每月的天数,默认为非闰年
            var days=new Array(31,28,31,30,31,30,31,31,30,31,30,31);
            if(this.isLeapYear(year))
            {
                //如果是闰年修改2月份天数为29天
                days[1]=29;
            }
            if(day<=0||day>days[month-1])
            {
                console.log("日期不符合规范");
                return false;
            }
            return true;
	}
	isLeapYear(year)
	{
	        if((year%4==0&&year%100!=0)||year%400==0)
            {
                return true;
            }
            else
            {
                return false;
            }
	}
	isEmail(value) {
		if (value != null && value != "") {
			let reg =/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			
			/*
				/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
*/
			return reg.test(value);
		} else
			return true;
	}

	isNoZhChar(value) { // 不包含中文
		if (value != null && value != "") {
			return (/^([^\u4e00-\u9fa5]+)?$/.test($.trim(value)));
		} else
			return false;
	}

	isLoginName(value) { // 账户 数字 字母 “_”
		let reg = /^[a-zA-z]\w{3,15}$/
		return reg.test(value);
	}

	isIp(value) {
		let reg =
			/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
		return reg.test(value);
	}
	isNumber(value) {
		let reg = new RegExp("^[0-9]*$");
		return reg.test(value);
	}
	
	isNumLen(val, len) { 
			let reg = /^(-?\d+)(\.\d+)?$/;
			if(val){
				if(reg.test(val)){
					let value = val.toString().split('.')[1];
					if(value && value.length > len) {
						return false;
					} else {
						return true;
					}
				} else {
					return false;
				}
			}
	}
	isInt(value) {
		let reg = /^\+?[1-9][0-9]*$/;
		return reg.test(value);
	}
	isFloat(value) {
		let reg = /^(-?\d+)(\.\d+)?$/
		return reg.test(value);
	}
	// http://www.cnblogs.com/xinwusuo/p/5948908.html

	checkQuote(str) {
		let items = new Array("~", "`", "!", "@", "#", "$", "%", "^", "&", "*",
			"{", "}", "[", "]", "(", ")");
		items.push(":", ";", "'", "|", "\\\\", "<", ">", "?", "/", "<<", ">>",
			"||", "//");
		items.push("admin", "administrators", "administrator", "管理员", "系统管理员");
		items.push("select", "delete", "update", "insert", "create", "drop",
			"alter", "trancate");
		str = str.toLowerCase();
		for (let i = 0; i < items.length; i++) {
			if (str.indexOf(items[i]) >= 0) {
				return true;
			}
		}
		return false;
	}
	
	 
	 toHump  (val)  {
		 if(!val)
		 {
			 return val;
		 }
		 val = val.toLowerCase();
	  const arr = val.split('')
	  const index = arr.indexOf('_')
	  arr.splice(index, 2, arr[index+1].toUpperCase())
	  val = arr.join('')
	  return val
	}
	 
	// 驼峰转换下划线
	  toLine(name) {
	  return name.replace(/([A-Z])/g,"_$1").toLowerCase();
	}
	 
	 



}
export default KeeVue;
